import React from "react";
import { loadModules } from "esri-loader";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { table } from "../UserDefinedRegion/table.css";
import { upiNegeriUrl, upiDaerahUrl, upiMukimUrl, upiSeksyenUrl, upiLotUrl, arcgisJSUrl, arcgisCSSUrl, arcgisGeocodeUrl } from "../../utilities/constants"

class UserDefinedRegionMapForm extends React.Component {
    // Then we add our constructor which receives our props
    constructor(props) {
        super(props);

        this.state = {
            currentCount: 0,
            displayTable: true,
            buffers: [],
            selectedOption: "",
            loading: false,
            tokenDetail: JSON.parse(localStorage.getItem("tokenDetail")),
            isChangeToken: false,
            apiUrl: arcgisJSUrl,
            apiCssUrl: arcgisCSSUrl,
            view: null,
            temporaryData: null,
            upiNegeri: [],
            selectedUPINegeri: "none",
            upiDaerah: [],
            selectedUPIDaerah: 'none',
            upiMukim: [],
            selectedUPIMukim: 'none',
            upiSeksyen: [],
            selectedUPISeksyen: 'none',
            queryKOD_NEGERI: '',
            queryKOD_DAERAH: '',
            queryKOD_MUKIM: '',
            queryKOD_SEKSYEN: '',
            upiLotInput: '',
            upiLotResult: [],
            upiLotLoading: false,
            isUPIShowed: false,
            pointCounter: 1,
            polylineCounter: 1,
            polygonCounter: 1,
            rectangleCounter: 1,
            circleCounter: 1,
            counter: 0
        };

        this.handleUPIChange = this.handleUPIChange.bind(this);
        //this.checkToken();
        //this.addToCartItem = this.addToCartItem.bind(this);
    }

    async componentDidMount() {
        // token working code
        //while (!this.state.isChangeToken) {
        //    try {
        //        await this.getToken();
        //        this.setState({
        //            isChangeToken: true
        //        });
        //    } finally {
        //    }
        //}
        //setInterval(() => {
        //    this.getToken();
        //}, 50000);

        fetch("api/GetData/GetConfigValues?configName=Buffer")
            .then(response => response.json())
            .then(data => {
                //console.log(data[0].value);
                this.setState({ buffers: data, selectedOption: data[0].value });
            });

        fetch("api/GetData/GetConfigValues?configName=PriceRate")
            .then(response => response.json())
            .then(data => {
                //console.log(data[0].value);
                this.setState({ priceRate: data[0].value });
            });

        this.getUPINegeriData();

        loadModules(
            [
                "esri/views/MapView",
                "esri/Map",
                "esri/widgets/Sketch",
                "esri/layers/GraphicsLayer",
                "esri/Graphic",
                "esri/geometry/geometryEngine",
                "esri/widgets/Search",
                "esri/widgets/BasemapGallery",
                "esri/widgets/Expand",
                "esri/layers/FeatureLayer",
                "esri/tasks/support/Query",
                "esri/symbols/TextSymbol",
                "esri/tasks/support/StatisticDefinition",
                "esri/identity/IdentityManager",
                "esri/widgets/ScaleBar",
                "esri/widgets/Home",
                "esri/widgets/Measurement",
                "esri/tasks/Locator",
            ],
            { url: this.state.apiUrl, css: this.state.apiUrl + this.state.apiCssUrl }
        )
            .then(
                ([
                    MapView,
                    Map,
                    Sketch,
                    GraphicsLayer,
                    Graphic,
                    geometryEngine,
                    Search,
                    BasemapGallery,
                    Expand,
                    FeatureLayer,
                    Query,
                    TextSymbol,
                    StatisticDefinition,
                    IdentityManager,
                    ScaleBar,
                    Home,
                    Measurement,
                    Locator
                ]) => {
                    const sketchLayer = new GraphicsLayer();
                    const bufferLayer = new GraphicsLayer();
                    //await this.letsWait();

                    //IdentityManager.registerToken({
                    //    server: "https://igis.iwk.com.my/geoserver/rest/services",
                    //    token: this.state.tokenDetail.token
                    //});

                    /*this.state.isChangeToken = false;
          
                      let checkTokenExpired = () => {
                          //console.log("check token");
                          if (this.state.isChangeToken) {
                              IdentityManager.registerToken({
                                  server: "https://igis.iwk.com.my/geoserver/rest/services",
                                  token: this.state.tokenDetail.token
                              });
                              this.state.isChangeToken = false;
                          }
                      };
          
                      setInterval(() => { checkTokenExpired() }, 5000);*/

                    //console.log({ ss: IdentityManager });

                    //var manholeLayer = new FeatureLayer({
                    //    url:
                    //        "https://igis.iwk.com.my/geoserver/rest/services/Production/IGIS_Asset/MapServer/2", // need to add as dynamic
                    //    outFields: ["OBJECTID"],
                    //    visible: false
                    //});

                    //var gravityMainsLayer = new FeatureLayer({
                    //    url:
                    //        "https://igis.iwk.com.my/geoserver/rest/services/Production/IGIS_Asset/MapServer/24", // need to add as dynamic
                    //    outFields: ["OBJECTID"],
                    //    visible: false
                    //});

                    //var pressurizedMainsLayer = new FeatureLayer({
                    //    url:
                    //        "https://igis.iwk.com.my/geoserver/rest/services/Production/IGIS_Asset/MapServer/21", // need to add as dynamic
                    //    outFields: ["OBJECTID"],
                    //    visible: false
                    //});

                    //var publicSTPLayer = new FeatureLayer({
                    //    url:
                    //        "https://igis.iwk.com.my/geoserver/rest/services/Production/IGIS_Asset/MapServer/10", // need to add as dynamic
                    //    outFields: ["OBJECTID"],
                    //    visible: false
                    //});

                    //var npsServiceAreaLayer = new FeatureLayer({
                    //    url:
                    //        "https://igis.iwk.com.my/geoserver/rest/services/Production/IGIS_Asset/MapServer/16", // need to add as dynamic
                    //    outFields: ["OBJECTID"],
                    //    visible: false
                    //});

                    // GraphicsLayer for displaying results - can delete this for testing purpose
                    //var resultsLayer = new GraphicsLayer();

                    const map = new Map({
                        basemap: "hybrid",
                        layers: [sketchLayer, bufferLayer]
                    });

                    const view = new MapView({
                        container: "viewDiv",
                        map: map,
                        zoom: 7,
                        center: [102, 4]
                    });

                    var homeBtn = new Home({
                        view: view
                    });

                    // Set the activeView to the 2D MapView
                    let activeView = view;

                    // Create new instance of the Measurement widget
                    const measurement = new Measurement();

                    this.setState({
                        view
                    });

                    const sketch = new Sketch({
                        layer: sketchLayer,
                        view: view
                    });

                    var scaleBar = new ScaleBar({
                        view: view,
                        unit: "dual"
                    });

                    var bufferSymbol = {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: [140, 140, 222, 0.5],
                        style: "solid",
                        outline: {
                            // autocasts as new SimpleLineSymbol()
                            color: [50, 50, 50, 255],
                            width: 2
                        }
                    };

                    var geometrySymbol = {
                        type: "simple-fill", // autocasts as new SimpleFillSymbol()
                        color: [140, 140, 222, 0.5],
                        outline: {
                            color: [0, 0, 0, 0.5],
                            width: 2
                        }
                    };

                    var geometrySymbolLine = {
                        type: "simple-line", // autocasts as new SimpleLineSymbol()
                        color: [140, 140, 222, 0.5],
                        width: "2px"
                    };

                    //var pointCounter = 1;
                    //var polylineCounter = 1;
                    //var polygonCounter = 1;
                    //var rectangleCounter = 1;
                    //var circleCounter = 1;
                    var counter = 0;

                    this.props.sketchGeometries.map(sketchGeometry => {
                        var bufferGraphic = sketchGeometry.BufferGraphic;
                        var labelGraphic = sketchGeometry.LabelGraphic;
                        var geometryGraphic = sketchGeometry.GeometryGraphic;

                        var textSymbol = new TextSymbol(labelGraphic.attributes.LabelId);

                        var shape = sketchGeometry.LabelGraphic.attributes.Shape;
                        bufferGraphic.symbol = bufferSymbol;
                        labelGraphic.symbol = textSymbol;

                        if (shape === "point") {
                            counter = this.state.pointCounter;
                            geometryGraphic.symbol = geometrySymbolLine;
                            sketchLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            //sketchLayer.add(geometryGraphic);
                            //pointCounter++;
                            this.setState({ pointCounter: this.state.pointCounter + 1 });
                        } else if (shape === "polyline") {
                            counter = this.state.polylineCounter;
                            geometryGraphic.symbol = geometrySymbolLine;
                            sketchLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            //sketchLayer.add(geometryGraphic);
                            //polylineCounter++;
                            this.setState({ polylineCounter: this.state.polylineCounter + 1 });
                        } else if (shape === "polygon") {
                            counter = this.state.polygonCounter;
                            geometryGraphic.symbol = geometrySymbol;
                            //bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            //sketchLayer.add(geometryGraphic);
                            sketchLayer.add(bufferGraphic);
                            //polygonCounter++;
                            this.setState({ polygonCounter: this.state.polygonCounter + 1 });
                        } else if (shape === "rectangle") {
                            counter = this.state.rectangleCounter;
                            geometryGraphic.symbol = geometrySymbol;
                            //bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            //sketchLayer.add(geometryGraphic);
                            sketchLayer.add(bufferGraphic);
                            //rectangleCounter++;
                            this.setState({ rectangleCounter: this.state.rectangleCounter + 1 });
                        } else if (shape === "circle") {
                            counter = this.state.circleCounter;
                            geometryGraphic.symbol = geometrySymbol;
                            //bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            //sketchLayer.add(geometryGraphic);
                            sketchLayer.add(bufferGraphic);
                            //circleCounter++;
                            this.setState({ circleCounter: this.state.circleCounter + 1 });
                        }
                    });

                    const searchWidget = new Search({
                        view: view,
                        container: "search",
                        includeDefaultSources: false,
                        locationEnabled: false,
                        autoSelect: true,
                        sources: [
                            {
                                locator: new Locator({ url: arcgisGeocodeUrl }),
                                singleLineFieldName: "SingleLine",
                                name: "Geocoding Service",
                                placeholder: "Find Address and Place",
                                maxResults: 3,
                                maxSuggestions: 6,
                                suggestionsEnabled: true,
                                minSuggestCharacters: 0
                            }
                        ]
                    });

                    searchWidget.on("search-focus", () => {
                        const inputs = document.querySelectorAll(".esri-search__input");
                        for (var i = 0; i < inputs.length; i++) {
                            inputs[i].onfocusout = null;
                        }
                    });

                    view.ui.add(scaleBar, {
                        position: "bottom-left"
                    });

                    view.ui.add(searchWidget, {
                        position: "top-left"
                    });

                    view.ui.add(sketch, "top-right");

                    view.ui.add(homeBtn, "top-left");

                    // Set-up event handlers for buttons and click events
                    const distanceButton = document.getElementById("distance");
                    const areaButton = document.getElementById("area");
                    const clearButton = document.getElementById("clear");

                    distanceButton.addEventListener("click", function () {
                        distanceMeasurement();
                    });
                    areaButton.addEventListener("click", function () {
                        areaMeasurement();
                    });
                    clearButton.addEventListener("click", function () {
                        clearMeasurements();
                    });

                    // Call the loadView() function for the initial view
                    loadView();

                    // The loadView() function to define the view for the widgets and div
                    function loadView() {
                        activeView.set({
                            container: "viewDiv"
                        });
                        // Add the appropriate measurement UI to the bottom-right when activated
                        activeView.ui.add(measurement, "bottom-right");

                        // Set the views for the widgets
                        measurement.view = activeView;
                    }

                    // Call the appropriate DistanceMeasurement2D or DirectLineMeasurement3D
                    function distanceMeasurement() {
                        const type = activeView.type;
                        measurement.activeTool = type.toUpperCase() === "2D" ? "distance" : "direct-line";
                        distanceButton.classList.add("active");
                        areaButton.classList.remove("active");
                    }

                    // Call the appropriate AreaMeasurement2D or AreaMeasurement3D
                    function areaMeasurement() {
                        measurement.activeTool = "area";
                        distanceButton.classList.remove("active");
                        areaButton.classList.add("active");
                    }

                    // Clears all measurements
                    function clearMeasurements() {
                        distanceButton.classList.remove("active");
                        areaButton.classList.remove("active");
                        measurement.clear();
                    }

                    sketch.on("create", function (event) {
                        if (event.state === "complete") {
                            this.setState(
                                { loading: true },
                                this.changeSketchButtonStatus()
                            );

                            //console.log("Geometry Type: " + event.graphic.geometry.type);
                            const bufferGeometry = geometryEngine.geodesicBuffer(
                                event.graphic.geometry,
                                this.state.selectedOption,
                                "meters"
                            );

                            let area =
                                (event.tool === "point" || event.tool === "polyline")
                                    ? geometryEngine
                                        .geodesicArea(bufferGeometry, "square-kilometers")
                                        .toFixed(2)
                                    : geometryEngine
                                        .geodesicArea(
                                            event.graphic.geometry,
                                            "square-kilometers"
                                        )
                                        .toFixed(2);
                            //console.log("Area: " + area);
                            area = (area == 0.00 ? 0.01 : area);

                            if (event.tool === "point") {
                                counter = this.state.pointCounter;
                                this.setState({ pointCounter: this.state.pointCounter + 1 });
                                //pointCounter++;
                            } else if (event.tool === "polyline") {
                                counter = this.state.polylineCounter;
                                this.setState({ polylineCounter: this.state.polylineCounter + 1 });
                                //polylineCounter++;
                            } else if (event.tool === "polygon") {
                                counter = this.state.polygonCounter;
                                this.setState({ polygonCounter: this.state.polygonCounter + 1 });
                                //polygonCounter++;
                            } else if (event.tool === "rectangle") {
                                counter = this.state.rectangleCounter;
                                this.setState({ rectangleCounter: this.state.rectangleCounter + 1 });
                                //rectangleCounter++;
                            } else if (event.tool === "circle") {
                                counter = this.state.circleCounter;
                                this.setState({ circleCounter: this.state.circleCounter + 1 });
                                //circleCounter++;
                            }

                            const id = event.tool + "_" + counter;
                            const shape = event.tool;

                            var attributes = {
                                //GeometryId: id
                                BufferId: id
                            };
                            event.graphic.attributes = attributes;

                            var pnt = bufferGeometry.centroid;
                            var txtSym = new TextSymbol(id);

                            var labelGraphic = new Graphic(pnt, txtSym, {
                                LabelId: id,
                                Shape: shape
                            });

                            var labelGraphicToSave = labelGraphic.toJSON();
                            labelGraphicToSave.geometry.type = labelGraphic.geometry.type;

                            bufferLayer.add(labelGraphic);

                            var bufferGraphic = new Graphic({
                                geometry: bufferGeometry,
                                symbol: bufferSymbol,
                                attributes: {
                                    BufferId: id
                                }
                            });

                            var bufferGraphicToSave = bufferGraphic.toJSON();
                            bufferGraphicToSave.geometry.type = bufferGraphic.geometry.type;

                            var geometryGraphicToSave = event.graphic.toJSON();
                            geometryGraphicToSave.geometry.type = event.graphic.geometry.type;

                            if (event.tool === "point" || event.tool === "polyline") {
                                sketchLayer.add(bufferGraphic);
                            }

                            //var countStatDef = new StatisticDefinition();
                            //countStatDef.statisticType = "count";
                            //countStatDef.onStatisticField = "OBJECTID";
                            //countStatDef.outStatisticFieldName = "numberOfFeatures";

                            //var queryParams = new Query();
                            var geometry = (event.tool === "point" || event.tool === "polyline" ? bufferGeometry : event.graphic.geometry);
                            //console.log({ geometry: geometry });
                            //queryParams.spatialRelationship = "intersects";
                            //queryParams.outFields = "OBJECTID";
                            //queryParams.outStatistics = [countStatDef];

                            //var manholeCount = 0;
                            //var gravityMainsCount = 0;
                            //var pressurizedMainsCount = 0;
                            //var publicSTPCount = 0;
                            //var npsServiceAreaCount = 0;

                            //let getManholeCount = function () {
                            //    return new Promise(function (resolve, reject) {
                            //        manholeLayer
                            //            .queryFeatures(queryParams)
                            //            .then(function (response) {
                            //                manholeCount =
                            //                    response.features[0].attributes.numberOfFeatures;
                            //                resolve();
                            //            });
                            //    });
                            //};

                            //let getGravityMainsCount = function () {
                            //    return new Promise(function (resolve, reject) {
                            //        gravityMainsLayer
                            //            .queryFeatures(queryParams)
                            //            .then(function (response) {
                            //                gravityMainsCount =
                            //                    response.features[0].attributes.numberOfFeatures;
                            //                resolve();
                            //            });
                            //    });
                            //};

                            //let getPressurizedMainsCount = function () {
                            //    return new Promise(function (resolve, reject) {
                            //        pressurizedMainsLayer
                            //            .queryFeatures(queryParams)
                            //            .then(function (response) {
                            //                pressurizedMainsCount =
                            //                    response.features[0].attributes.numberOfFeatures;
                            //                resolve();
                            //            });
                            //    });
                            //};

                            //let getPublicSTPCount = function () {
                            //    return new Promise(function (resolve, reject) {
                            //        publicSTPLayer
                            //            .queryFeatures(queryParams)
                            //            .then(function (response) {
                            //                publicSTPCount =
                            //                    response.features[0].attributes.numberOfFeatures;
                            //                resolve();
                            //            });
                            //    });
                            //};

                            //let getNPSServiceAreaCount = function () {
                            //    return new Promise(function (resolve, reject) {
                            //        npsServiceAreaLayer
                            //            .queryFeatures(queryParams)
                            //            .then(function (response) {
                            //                npsServiceAreaCount =
                            //                    response.features[0].attributes.numberOfFeatures;
                            //                resolve();
                            //            });
                            //    });
                            //};

                            fetch('api/Order/GetFeatureCount?geometry=' + JSON.stringify(geometry))
                                .then(response => response.json())
                                //.then(data => {
                                //    console.log({ data });   
                                //    var featuresCounts = data.dataReturn;
                                //    var manholeCount = featuresCounts.ManholeCount

                                //})
                                .then(
                                    function (data) {
                                        var features = data.dataReturn;
                                        //console.log({ data });
                                        //console.log({ features });

                                        var sketchGeometryDetails = {
                                            Buffer: this.state.selectedOption,
                                            BufferGraphic:
                                                event.tool === "point" || event.tool === "polyline"
                                                    ? bufferGraphicToSave
                                                    : geometryGraphicToSave,
                                            GeometryGraphic: geometryGraphicToSave,
                                            LabelGraphic: labelGraphicToSave,
                                            Area: area,
                                            Price: parseFloat((area * this.state.priceRate).toFixed(2)) == 6.25 ? 10.00 : parseFloat((area * this.state.priceRate).toFixed(2)),
                                            //GeometryId: id,
                                            BufferId: id,
                                            LabelId: id,
                                            AddToCart: false,
                                            Manhole: features.manholeCount,
                                            GravityMains: features.gravityMainsCount,
                                            PressurizedMains: features.pressurizedMainsCount,
                                            PublicSTP: features.publicSTPCount,
                                            NPSServiceArea: features.npsServiceAreaCount,
                                            Shape: shape,
                                            GeometryType: event.graphic.geometry.type
                                        };

                                        this.props.onSetState([
                                            ...this.props.sketchGeometries,
                                            sketchGeometryDetails
                                        ]);

                                        this.setState(
                                            { loading: false },
                                            this.changeSketchButtonStatus()
                                        );
                                    }.bind(this)
                                );



                            //getManholeCount()
                            //    .then(getGravityMainsCount)
                            //    .then(getPressurizedMainsCount)
                            //    .then(getPublicSTPCount)
                            //    .then(getNPSServiceAreaCount)
                            //    .then(
                            //        function () {
                            //            var sketchGeometryDetails = {
                            //                Buffer: this.state.selectedOption,
                            //                BufferGraphic:
                            //                    event.tool === "point" || event.tool === "polyline"
                            //                        ? bufferGraphicToSave
                            //                        : geometryGraphicToSave,
                            //                GeometryGraphic: geometryGraphicToSave,
                            //                LabelGraphic: labelGraphicToSave,
                            //                Area: area,
                            //                Price: parseFloat(
                            //                    (area * this.state.priceRate).toFixed(2)
                            //                ), // need to get from table
                            //                GeometryId: id,
                            //                BufferId: id,
                            //                LabelId: id,
                            //                AddToCart: false,
                            //                Manhole: manholeCount,
                            //                GravityMains: gravityMainsCount,
                            //                PressurizedMains: pressurizedMainsCount,
                            //                PublicSTP: publicSTPCount,
                            //                NPSServiceArea: npsServiceAreaCount,
                            //                Shape: shape,
                            //                GeometryType: event.graphic.geometry.type
                            //            };

                            //            this.props.onSetState([
                            //                ...this.props.sketchGeometries,
                            //                sketchGeometryDetails
                            //            ]);
                            //            this.setState(
                            //                { loading: false },
                            //                this.changeSketchButtonStatus()
                            //            );
                            //        }.bind(this)
                            //    );
                        }
                        }.bind(this)
                    );

                    sketch.on("update", function (event) {
                        //if (event.toolEventInfo && (event.toolEventInfo.type.includes("move"))) {
                            sketch.cancel();
                        //}
                    });

                    var bufferId = 0;

                    sketch.view.when(() => {
                        var panel = document.querySelector(".esri-sketch__panel");
                        panel.removeChild(panel.childNodes[0]);
                        panel.removeChild(panel.childNodes[1]);
                    });

                    sketch.on(
                        "delete",
                        function (event) {
                            bufferId = event.graphics[0].attributes.BufferId;

                            if (!bufferId) {
                                bufferId = event.graphics[0].attributes.BufferId;
                            }

                            const items = this.props.sketchGeometries.filter(
                                item => item.BufferId !== bufferId
                            );

                            this.setState({
                                pointCounter: 1,
                                polylineCounter: 1,
                                polygonCounter: 1,
                                rectangleCounter: 1,
                                circleCounter: 1
                            });

                            //pointCounter = 1;
                            //polylineCounter = 1;
                            //polygonCounter = 1;
                            //rectangleCounter = 1;
                            //circleCounter = 1;
                            counter = 1;

                            bufferLayer.removeAll();
                            sketchLayer.removeAll();

                            items.map(sketchGeometry => {
                                var shape = sketchGeometry.LabelGraphic.attributes.Shape;

                                if (shape === "point") {
                                    counter = this.state.pointCounter;
                                    this.setState({ pointCounter: this.state.pointCounter + 1 });
                                } else if (shape === "polyline") {
                                    //counter = polylineCounter;
                                    //polylineCounter++;
                                    counter = this.state.polylineCounter;
                                    this.setState({ polylineCounter: this.state.polylineCounter + 1 });
                                } else if (shape === "polygon") {
                                    //counter = polygonCounter;
                                    //polygonCounter++;
                                    counter = this.state.polygonCounter;
                                    this.setState({ polygonCounter: this.state.polygonCounter + 1 });
                                } else if (shape === "rectangle") {
                                    //counter = rectangleCounter;
                                    //rectangleCounter++;
                                    counter = this.state.rectangleCounter;
                                    this.setState({ rectangleCounter: this.state.rectangleCounter + 1 });
                                } else if (shape === "circle") {
                                    //counter = circleCounter;
                                    //circleCounter++;
                                    counter = this.state.circleCounter;
                                    this.setState({ circleCounter: this.state.circleCounter + 1 });
                                }

                                var id = shape + "_" + counter;

                                //sketchGeometry.GeometryId = id;
                                sketchGeometry.BufferId = id;
                                sketchGeometry.LabelId = id;

                                sketchGeometry.GeometryGraphic.attributes.BufferId = id;
                                sketchGeometry.BufferGraphic.attributes.BufferId = id;
                                sketchGeometry.LabelGraphic.attributes.LabelId = id;

                                var bufferGraphic = sketchGeometry.BufferGraphic;
                                var labelGraphic = sketchGeometry.LabelGraphic;
                                var geometryGraphic = sketchGeometry.GeometryGraphic;

                                var textSymbol = new TextSymbol(
                                    labelGraphic.attributes.LabelId
                                );

                                bufferGraphic.symbol = bufferSymbol;
                                labelGraphic.symbol = textSymbol;

                                if (shape === "point") {
                                    geometryGraphic.symbol = geometrySymbolLine;
                                    sketchLayer.add(bufferGraphic);
                                    bufferLayer.add(labelGraphic);
                                    sketchLayer.add(geometryGraphic);
                                } else if (shape === "polyline") {
                                    geometryGraphic.symbol = geometrySymbolLine;
                                    sketchLayer.add(bufferGraphic);
                                    bufferLayer.add(labelGraphic);
                                    sketchLayer.add(geometryGraphic);
                                } else if (shape === "polygon") {
                                    geometryGraphic.symbol = geometrySymbol;
                                    bufferLayer.add(bufferGraphic);
                                    bufferLayer.add(labelGraphic);
                                    sketchLayer.add(geometryGraphic);
                                } else if (shape === "rectangle") {
                                    geometryGraphic.symbol = geometrySymbol;
                                    bufferLayer.add(bufferGraphic);
                                    bufferLayer.add(labelGraphic);
                                    sketchLayer.add(geometryGraphic);
                                } else if (shape === "circle") {
                                    geometryGraphic.symbol = geometrySymbol;
                                    bufferLayer.add(bufferGraphic);
                                    bufferLayer.add(labelGraphic);
                                    sketchLayer.add(geometryGraphic);
                                }
                            });

                            this.props.onSetState(items);
                        }.bind(this)
                    );

                    var basemapGallery = new BasemapGallery({
                        view: view
                    });

                    var bgExpand = new Expand({
                        view: view,
                        expandIconClass: "esri-icon-basemap",
                        expandTooltip: "Basemap",
                        content: basemapGallery
                    });

                    // Add widget to the top right corner of the view
                    view.ui.add(bgExpand, "top-right");
                }
            )
            .catch(err => {
                // handle any errors
                console.error(err);
            });
    }

    /*async checkToken() {
          var tokenDetail = localStorage.getItem("tokenDetail");
          if (tokenDetail != null) {
              tokenDetail = JSON.parse(tokenDetail);
          }
  
          if (tokenDetail == null || new Date() > new Date(tokenDetail.tokenExpired)) {
              //console.log("get token");
              this.state.isChangeToken = true;
  
              let jj = async () => {
                  return new Promise(resolve => {
                      fetch('api/GetData/GetTokenArcgis')
                          .then(response => response.json())
                          .then(data => {
                              //console.log({ data });                      
                              var dd = new Date();
                              dd.setHours(dd.getHours() + 1)
                              tokenDetail = { token: data.token, tokenExpired: dd };
                              this.setState({ tokenDetail: tokenDetail });
                              localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
                              resolve(1);
                          });
                  });
              };
              await jj();
              this.state.tokenDetail = JSON.parse(localStorage.getItem("tokenDetail"));
          }
          setTimeout(() => { this.checkToken() }, 30000);
      }*/

    /*letsWait = () => {
          //console.log({ dd: this });
          return new Promise(resolve => {
              if (this.state.tokenDetail == null) {
                  //console.log("token detail null");
                  setTimeout(() => { this.letsWait() }, 3000);
              }
              else {
                  resolve(1);
              }
          });
      };*/

    changeSketchButtonStatus = () => {
        var sketchButton = document.querySelectorAll(
            ".esri-sketch__tool-section button"
        );
        for (var i = 0; i < sketchButton.length; i++) {
            sketchButton[i].disabled = !this.state.loading;
        }
    };

    //Working token code
    //getToken = () => {
    //    return new Promise(async (resolve, reject) => {
    //        if (
    //            !this.state.tokenDetail ||
    //            new Date() > new Date(this.state.tokenDetail.tokenExpired)
    //        ) {
    //            try {
    //                await this.fetchToken();
    //            } catch (err) {
    //                reject(err);
    //            }
    //        }
    //        resolve(true);
    //    });
    //};

    //fetchToken = async () => {
    //    var response = await fetch("api/GetData/GetTokenArcgis");
    //    var data = await response.json();
    //    var dd = new Date();
    //    dd.setHours(dd.getHours() + 1);
    //    var tokenDetail = { token: data.token, tokenExpired: dd };
    //    this.setState({ tokenDetail });
    //    localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
    //};

    async handleUPIChange(
        event,
        changeState,
        state,
        nextURL,
        outfields,
        nextStateProp,
        filterAttr,
        fetchAttr,
        zoomLevel
    ) {
        event.persist()
        event.preventDefault()
        this.setState(changeState);
        var targetArr = []
        if (filterAttr) {
            for (var i = 0; i < state.length; i++) {
                if (state[i].attributes[filterAttr] === event.target.value) {
                    targetArr = state[i]
                    this.zoomMap(targetArr.geometry, zoomLevel)
                    break
                }
            }
        }
        if (outfields) {
            var query = this.getFetchQuery(targetArr, fetchAttr)
            var response = await fetch(nextURL + 'query?where=' + query + '&outfields=' + outfields + '&f=json&orderByFields=' + outfields[0])
            var data = await response.json()
            var nextState = new Object()
        }
        if (nextStateProp) {
            if (!data.features || data.features.length === 0) {
                data.features = ["No data available"]
            }
            nextState[nextStateProp] = data.features
        }
        if (nextState) {
            this.setState(nextState)
        }
    }

    getFetchQuery(targetArr, fetchAttr) {
        var fetchQuery = ''
        if (fetchAttr === 'KOD_NEGERI') {
            console.log(targetArr.attributes);
            //fetchQuery += fetchAttr + '=' + targetArr.attributes[fetchAttr]
            fetchQuery += fetchAttr + "='" + targetArr.attributes[fetchAttr] + "'";
            this.setState({
                upiDaerah: [],
                queryKOD_NEGERI: targetArr.attributes[fetchAttr],
                queryNAM_NEGERI: targetArr.attributes["NAM"],
                selectedUPIDaerah: 'none',
                upiMukim: [],
                selectedUPIMukim: 'none',
                upiSeksyen: [],
                selectedUPISeksyen: 'none',
                upiLotResult: []
            })
        } else if (fetchAttr === 'KOD_DAERAH') {
            //fetchQuery += 'KOD_NEGERI=' + this.state.queryKOD_NEGERI + ' AND KOD_DAERAH=' + targetArr.attributes[fetchAttr]
            fetchQuery += "KOD_NEGERI='" + this.state.queryKOD_NEGERI + "' AND KOD_DAERAH='" + targetArr.attributes[fetchAttr] + "'";

            this.setState({
                upiMukim: [],
                queryKOD_DAERAH: targetArr.attributes[fetchAttr],
                queryNAM_DAERAH: targetArr.attributes["NAM"],
                selectedUPIMukim: 'none',
                upiSeksyen: [],
                selectedUPISeksyen: 'none',
                upiLotResult: []
            })
        } else if (fetchAttr === 'KOD_MUKIM') {
            //fetchQuery += 'KOD_NEGERI=' + this.state.queryKOD_NEGERI + ' AND KOD_DAERAH=' + this.state.queryKOD_DAERAH + ' AND KOD_MUKIM=' + targetArr.attributes[fetchAttr]
            fetchQuery += "KOD_NEGERI='" + this.state.queryKOD_NEGERI +
                "' AND KOD_DAERAH='" + this.state.queryKOD_DAERAH +
                "' AND KOD_MUKIM='" + targetArr.attributes[fetchAttr] + "'";

            this.setState({
                upiSeksyen: [],
                selectedUPISeksyen: 'none',
                queryKOD_MUKIM: targetArr.attributes[fetchAttr],
                queryNAM_MUKIM: targetArr.attributes["NAM"],
                upiLotResult: []
            })
        } else if (fetchAttr === 'KOD_SEKSYEN') {
            //fetchQuery += 'KOD_NEGERI=' + this.state.queryKOD_NEGERI + ' AND KOD_DAERAH=' + this.state.queryKOD_DAERAH + ' AND KOD_MUKIM=' + this.state.queryKOD_MUKIM + ' AND KOD_SEKSYEN=' + targetArr.attributes[fetchAttr]
            fetchQuery += "KOD_NEGERI='" + this.state.queryKOD_NEGERI +
                "' AND KOD_DAERAH='" + this.state.queryKOD_DAERAH +
                "' AND KOD_MUKIM='" + this.state.queryKOD_MUKIM +
                "' AND KOD_SEKSYEN='" + targetArr.attributes[fetchAttr] + "'";

            this.setState({
                queryKOD_SEKSYEN: targetArr.attributes[fetchAttr],
                upiLotResult: []
            })
        }
        return fetchQuery
    }

    getUPINegeriData() {
        fetch(
            upiNegeriUrl + "query?where=1=1&outfields=KOD_NEGERI,NAM&f=json&orderByFields=KOD_NEGERI"
        )
            .then(response => response.json())
            .then(data =>
                this.setState({
                    upiNegeri: data.features
                })
            );
    }

    getUPILotNumber() {
        if (new RegExp('^[0-9]{3,7}$').test(this.state.upiLotInput)) {
            console.log(this.state.queryKOD_NEGERI);


            var upi = ` LIKE '${this.state.queryKOD_NEGERI}${this.state.queryKOD_DAERAH}${this.state.queryKOD_MUKIM}${this.state.queryKOD_SEKSYEN}%25'`
            console.log(upi);
            this.setState({
                upiLotLoading: true,
                upiLotResult: []
            })
			
			console.log(this.state.tokenDetail)
            var token = this.state.tokenDetail

            if (!this.state.tokenDetail) {
                this.state.tokenDetail = JSON.parse(localStorage.getItem("tokenDetail"))
                console.log(this.state.tokenDetail)
            }
			
            fetch(`${upiLotUrl}query?f=json&where=UPI${upi} AND LOT LIKE '%25${this.state.upiLotInput}%25'&token=${this.state.tokenDetail.token}&outfields=NEGERI,DAERAH,MUKIM,SEKSYEN,LOT,UPI`)
                .then(response => response.json())
                .then(data => {
                    if (data.features) {
                        if (data.features.length === 0) {
                            data.features = ["No data available"]
                        }
                    } else {
                        data.features = ["No data available"]
                    }
                    this.setState({
                        upiLotResult: data.features,
                        upiLotLoading: false
                    })
                })
                .catch(() => {
                    this.setState({
                        upiLotLoading: false
                    })
                })
        }
    }

    zoomUPILot(lot) {
        this.zoomMap(lot.geometry, 20)
        this.state.view.graphics.pop()
        loadModules(["esri/Graphic"])
            .then(([Graphic]) => {
                var polygon = {
                    type: "polygon",
                    rings: lot.geometry.rings
                };

                var simpleFillSymbol = {
                    type: "simple-fill",
                    color: [227, 139, 79, 0.8],  // orange, opacity 80%
                    outline: {
                        color: [255, 255, 255],
                        width: 1
                    }
                };

                var polygonGraphic = new Graphic({
                    geometry: polygon,
                    symbol: simpleFillSymbol
                });
                this.state.view.graphics.add(polygonGraphic);
            })
    }

    zoomMap(geometry, zoomLevel) {
        loadModules(["esri/geometry/Polygon"]).then(([Polygon]) => {
            var polygon = new Polygon({
                rings: geometry.rings,
                spatialReference: { wkid: 4326 }
            })
            this.state.view.goTo({ target: polygon, zoom: zoomLevel })
        })
    }

    zoomToBookmark = geometry => {
        loadModules(["esri/geometry/support/webMercatorUtils"]).then(
            ([webMercatorUtils]) => {
                var target = webMercatorUtils.webMercatorToGeographic(geometry.target);
                geometry.target = [target.rings];
                //console.log(geometry);
                this.state.view.goTo(geometry, {
                    duration: 3500
                });
            }
        );
    };

    deleteGraphic = id => {
        if (window.confirm("Do you really want to delete?")) {
            ////console.log(this.state.view.map.layers.items[0].graphics.items[0].attributes.GeometryId);
            //var graphicSketechLayer = this.state.view.map.layers.items[0].graphics.items.filter(x => x.attributes.BufferId === id.target); // Sketch Layer
            //var graphicBufferLayer = this.state.view.map.layers.items[1].graphics.items.filter(x => x.attributes.LabelId === id.target); // Buffer Layer
            //this.state.view.map.layers.items[0].removeMany(graphicSketechLayer);
            ////this.state.view.map.layers.items[1].removeAll();
            //this.state.view.map.layers.items[1].removeMany(graphicBufferLayer);

            loadModules(["esri/symbols/TextSymbol"]).then(
                ([TextSymbol]) => {
                    const items = this.props.sketchGeometries.filter(
                        item => item.BufferId !== id.target
                    );


                    this.setState({
                        pointCounter: 1,
                        polylineCounter: 1,
                        polygonCounter: 1,
                        rectangleCounter: 1,
                        circleCounter: 1
                    });

                    //var pointCounter = 1;
                    //var polylineCounter = 1;
                    //var polygonCounter = 1;
                    //var rectangleCounter = 1;
                    //var circleCounter = 1;
                    var counter = 1;

                    var sketchLayer = this.state.view.map.layers.items[0];
                    var bufferLayer = this.state.view.map.layers.items[1];

                    sketchLayer.removeAll(); //sketch layer
                    bufferLayer.removeAll(); //buffer layer 

                    items.map(sketchGeometry => {
                        var shape = sketchGeometry.LabelGraphic.attributes.Shape;

                        if (shape === "point") {
                            counter = this.state.pointCounter;
                            this.setState({ pointCounter: this.state.pointCounter + 1 });
                        } else if (shape === "polyline") {
                            //counter = polylineCounter;
                            //polylineCounter++;
                            counter = this.state.polylineCounter;
                            this.setState({ polylineCounter: this.state.polylineCounter + 1 });
                        } else if (shape === "polygon") {
                            //counter = polygonCounter;
                            //polygonCounter++;
                            counter = this.state.polygonCounter;
                            this.setState({ polygonCounter: this.state.polygonCounter + 1 });
                        } else if (shape === "rectangle") {
                            //counter = rectangleCounter;
                            //rectangleCounter++;
                            counter = this.state.rectangleCounter;
                            this.setState({ rectangleCounter: this.state.rectangleCounter + 1 });
                        } else if (shape === "circle") {
                            //counter = circleCounter;
                            //circleCounter++;
                            counter = this.state.circleCounter;
                            this.setState({ circleCounter: this.state.circleCounter + 1 });
                        }

                        var id = shape + "_" + counter;
                        //console.log(counter)
                        //console.log(shape)
                        //sketchGeometry.GeometryId = id;
                        sketchGeometry.BufferId = id;
                        sketchGeometry.LabelId = id;

                        sketchGeometry.GeometryGraphic.attributes.BufferId = id;
                        sketchGeometry.BufferGraphic.attributes.BufferId = id;
                        sketchGeometry.LabelGraphic.attributes.LabelId = id;

                        var bufferGraphic = sketchGeometry.BufferGraphic;
                        var labelGraphic = sketchGeometry.LabelGraphic;
                        var geometryGraphic = sketchGeometry.GeometryGraphic;

                        var textSymbol = new TextSymbol(
                            labelGraphic.attributes.LabelId
                        );

                        var bufferSymbol = {
                            type: "simple-fill", // autocasts as new SimpleFillSymbol()
                            color: [140, 140, 222, 0.5],
                            style: "solid",
                            outline: {
                                // autocasts as new SimpleLineSymbol()
                                color: [50, 50, 50, 255],
                                width: 2
                            }
                        };

                        var geometrySymbol = {
                            type: "simple-fill", // autocasts as new SimpleFillSymbol()
                            color: [140, 140, 222, 0.5],
                            outline: {
                                color: [0, 0, 0, 0.5],
                                width: 2
                            }
                        };

                        var geometrySymbolLine = {
                            type: "simple-line", // autocasts as new SimpleLineSymbol()
                            color: [140, 140, 222, 0.5],
                            width: "2px"
                        };

                        bufferGraphic.symbol = bufferSymbol;
                        labelGraphic.symbol = textSymbol;

                        if (shape === "point") {                          
                            geometryGraphic.symbol = geometrySymbolLine;
                            sketchLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            sketchLayer.add(geometryGraphic);
                        } else if (shape === "polyline") {
                            geometryGraphic.symbol = geometrySymbolLine;
                            sketchLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            sketchLayer.add(geometryGraphic);
                        } else if (shape === "polygon") {
                            geometryGraphic.symbol = geometrySymbol;
                            bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            sketchLayer.add(geometryGraphic);
                        } else if (shape === "rectangle") {
                            geometryGraphic.symbol = geometrySymbol;
                            bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            sketchLayer.add(geometryGraphic);
                        } else if (shape === "circle") {
                            geometryGraphic.symbol = geometrySymbol;
                            bufferLayer.add(bufferGraphic);
                            bufferLayer.add(labelGraphic);
                            sketchLayer.add(geometryGraphic);
                        }
                    });

                    this.props.onSetState(items); 
                }
            );

            //const sketchGeometryDetails = this.props.sketchGeometries.filter(
            //    item => item.BufferId !== id.target
            //);
            ////console.log(sketchGeometryDetails);
            //this.props.onSetState(sketchGeometryDetails);
        }
    };

    render() {
        //console.log(this.props.sketchGeometries);
        return (
            <div>
                <div className="form-group">
                    <span className="pr-2 pl-2">Buffer Radius:</span>
                    {this.state.buffers.map(buffer => (
                        <div
                            className="custom-control custom-radio custom-control-inline"
                            key={buffer.configValueId}
                        >
                            <input
                                type="radio"
                                id={buffer.value}
                                name="bufferRadio"
                                className="custom-control-input"
                                value={buffer.value}
                                checked={this.state.selectedOption === buffer.value}
                                onChange={e =>
                                    this.setState({ selectedOption: e.target.value })
                                }
                            />
                            <label
                                className="custom-control-label"
                                htmlFor={buffer.value}
                            >
                                {buffer.value} meters
                  </label>
                        </div>
                    ))}
                    <br />
                    <span className="small pl-2">
                        <strong>
                            The buffer Radius only applied to point and polyline draw
                            geometry.
                </strong>
                    </span>
                </div>
                <div style={{ position: "relative" }}>
                    <div id="viewDiv" className="mapViews"></div>
                    <div id="toolbarDiv" className="esri-component esri-widget">
                        <button
                            id="distance"
                            className="esri-widget--button esri-interactive esri-icon-measure-line"
                            title="Distance Measurement Tool"
                        ></button>
                        <button
                            id="area"
                            className="esri-widget--button esri-interactive esri-icon-measure-area"
                            title="Area Measurement Tool"
                        ></button>
                        <button
                            id="clear"
                            className="esri-widget--button esri-interactive esri-icon-trash"
                            title="Clear Measurements"
                        ></button>
                    </div>
                    <div id="search"></div>
                    <div id="upi" style={this.state.isUPIShowed ? {} : {
                        "height": "50px", "width": "50px", "background": "#fff", "textAlign": "center"
                    }}>
                        <h5 onClick={() => this.setState({ isUPIShowed: !this.state.isUPIShowed })} style={{ "cursor": "pointer" }}>
                            <span aria-hidden="true" className={this.state.isUPIShowed ? "esri-icon-close-circled" : "esri-icon-public"}></span>{" "}
                            {this.state.isUPIShowed ? "Unique Parcel Identifier" : ""}
                        </h5>
                        {this.state.isUPIShowed && <div>
                            <form onSubmit={(event) => event.preventDefault()}>
                                <div className="form-group">
                                    <label htmlFor="negeri">Negeri</label>
                                    <select
                                        className="form-control"
                                        id="negeri"
                                        value={this.state.selectedUPINegeri}
                                        onChange={event =>
                                            this.handleUPIChange(
                                                event,
                                                {
                                                    selectedUPINegeri: event.target.value
                                                },
                                                this.state.upiNegeri,
                                                upiDaerahUrl,
                                                ["KOD_DAERAH", "NAM"],
                                                "upiDaerah",
                                                "NAM",
                                                "KOD_NEGERI",
                                                10
                                            )
                                        }
                                        disabled={
                                            this.state.upiNegeri.length === 0 ||
                                            this.state.upiNegeri[0] === "No data available" ||
                                            this.state.upiLotLoading
                                        }
                                    >
                                        <option hidden disabled value="none">
                                            {" "}
                                            --{" "}
                                            {this.state.upiNegeri[0] === "No data available"
                                                ? "No data available"
                                                : "Select Negeri Option(s)"}{" "}
                                            --{" "}
                                        </option>
                                        {this.state.upiNegeri[0] !== "No data available" && this.state.upiNegeri.map(negeri => (
                                            <option
                                                key={negeri.attributes.NAM}
                                                value={negeri.attributes.NAM}
                                            >
                                                {" "}
                                                {negeri.attributes.KOD_NEGERI} -{" "}
                                                {negeri.attributes.NAM}{" "}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.upiNegeri.length === 0 && (
                                        <small
                                            id="passwordHelpBlock"
                                            className="form-text text-muted"
                                        >
                                            <div
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                            >
                                                <span className="sr-only">Loading...</span>
                                            </div>{" "}
                                            Loading data..
                      </small>
                                    )}
                                </div>

                                {this.state.selectedUPINegeri &&
                                    this.state.selectedUPINegeri !== "none" && (
                                        <div className="form-group">
                                            <label htmlFor="daerah">Daerah</label>
                                            <select
                                                className="form-control"
                                                id="daerah"
                                                value={this.state.selectedUPIDaerah}
                                                onChange={event =>
                                                    this.handleUPIChange(
                                                        event,
                                                        {
                                                            selectedUPIDaerah: event.target.value
                                                        },
                                                        this.state.upiDaerah,
                                                        upiMukimUrl,
                                                        ["KOD_MUKIM", "NAM"],
                                                        "upiMukim",
                                                        "NAM",
                                                        "KOD_DAERAH",
                                                        12
                                                    )
                                                }
                                                disabled={
                                                    this.state.upiDaerah.length === 0 ||
                                                    this.state.upiDaerah[0] === "No data available" ||
                                                    this.state.upiLotLoading
                                                }
                                            >
                                                <option hidden disabled value="none">
                                                    {" "}
                                                    --{" "}
                                                    {this.state.upiDaerah[0] === "No data available"
                                                        ? "No data available"
                                                        : "Select Daerah Option(s)"}{" "}
                                                    --{" "}
                                                </option>
                                                {this.state.upiDaerah[0] !== "No data available" && this.state.upiDaerah.map(daerah => (
                                                    <option
                                                        key={daerah.attributes.NAM}
                                                        value={daerah.attributes.NAM}
                                                    >
                                                        {" "}
                                                        {daerah.attributes.KOD_DAERAH} -{" "}
                                                        {daerah.attributes.NAM}{" "}
                                                    </option>
                                                ))}
                                            </select>
                                            {this.state.upiDaerah.length === 0 && (
                                                <small
                                                    id="passwordHelpBlock"
                                                    className="form-text text-muted"
                                                >
                                                    <div
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                    >
                                                        <span className="sr-only">Loading...</span>
                                                    </div>{" "}
                                                    Loading data..
                          </small>
                                            )}
                                        </div>
                                    )}

                                {this.state.selectedUPIDaerah &&
                                    this.state.selectedUPIDaerah !== "none" && (
                                        <div className="form-group">
                                            <label htmlFor="daerah">Mukim/Bandar/Pekan</label>
                                            <select
                                                className="form-control"
                                                id="daerah"
                                                value={this.state.selectedUPIMukim}
                                                onChange={event =>
                                                    this.handleUPIChange(
                                                        event,
                                                        {
                                                            selectedUPIMukim: event.target.value
                                                        },
                                                        this.state.upiMukim,
                                                        upiSeksyenUrl,
                                                        ["KOD_SEKSYEN", "NAM"],
                                                        "upiSeksyen",
                                                        "NAM",
                                                        "KOD_MUKIM",
                                                        14
                                                    )
                                                }
                                                disabled={
                                                    this.state.upiMukim.length === 0 ||
                                                    this.state.upiMukim[0] === "No data available" ||
                                                    this.state.upiLotLoading
                                                }
                                            >
                                                <option hidden disabled value="none">
                                                    {" "}
                                                    --{" "}
                                                    {this.state.upiMukim[0] === "No data available"
                                                        ? "No data available"
                                                        : "Select Mukim Option(s)"}{" "}
                                                    --{" "}
                                                </option>
                                                {this.state.upiMukim[0] !== "No data available" && this.state.upiMukim.map(daerah => (
                                                    <option
                                                        key={daerah.attributes.NAM}
                                                        value={daerah.attributes.NAM}
                                                    >
                                                        {" "}
                                                        {daerah.attributes.KOD_MUKIM} -{" "}
                                                        {daerah.attributes.NAM}{" "}
                                                    </option>
                                                ))}
                                            </select>
                                            {this.state.upiMukim.length === 0 && (
                                                <small
                                                    id="passwordHelpBlock"
                                                    className="form-text text-muted"
                                                >
                                                    <div
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                    >
                                                        <span className="sr-only">Loading...</span>
                                                    </div>{" "}
                                                    Loading data..
                          </small>
                                            )}
                                        </div>
                                    )}

                                {this.state.selectedUPIMukim &&
                                    this.state.selectedUPIMukim !== "none" && (
                                        <div className="form-group">
                                            <label htmlFor="daerah">Seksyen</label>
                                            <select
                                                className="form-control"
                                                id="daerah"
                                                value={this.state.selectedUPISeksyen}
                                                onChange={event =>
                                                    this.handleUPIChange(
                                                        event,
                                                        {
                                                            selectedUPISeksyen: event.target.value
                                                        },
                                                        this.state.upiSeksyen,
                                                        null,
                                                        null,
                                                        null,
                                                        "NAM",
                                                        "KOD_SEKSYEN",
                                                        16
                                                    )
                                                }
                                                disabled={
                                                    this.state.upiSeksyen.length === 0 ||
                                                    this.state.upiSeksyen[0] === "No data available" ||
                                                    this.state.upiLotLoading
                                                }
                                            >
                                                <option hidden disabled value="none">
                                                    {" "}
                                                    --{" "}
                                                    {this.state.upiSeksyen[0] === "No data available"
                                                        ? "No data available"
                                                        : "Select Mukim Option(s)"}{" "}
                                                    --{" "}
                                                </option>
                                                {this.state.upiSeksyen[0] !== "No data available" && this.state.upiSeksyen.map(daerah => (
                                                    <option
                                                        key={daerah.attributes.NAM}
                                                        value={daerah.attributes.NAM}
                                                    >
                                                        {" "}
                                                        {daerah.attributes.KOD_SEKSYEN} -{" "}
                                                        {daerah.attributes.NAM}{" "}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}

                                {this.state.selectedUPIMukim &&
                                    this.state.selectedUPIMukim !== "none" && (
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="lotNumber">Lot Number</label>
                                                <input
                                                    id="lotNumber"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Lot Number"
                                                    aria-label="Lot Number"
                                                    aria-describedby="button-addon2"
                                                    onChange={event => {
                                                        this.setState({
                                                            upiLotInput: event.target.value,
                                                            upiLotResult: []
                                                        });
                                                    }}
                                                    disabled={this.state.upiLotLoading}
                                                />
                                                {!this.state.upiLotLoading && (
                                                    <small
                                                        id="passwordHelpBlock"
                                                        className="form-text text-muted"
                                                    >
                                                        Lot number must be 3-7 characters long and contain
                                                        only numbers.
                            </small>
                                                )}
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-info btn-sm"
                                                    type="button"
                                                    id="button-addon2"
                                                    onClick={event => {
                                                        this.getUPILotNumber(event);
                                                    }}
                                                    disabled={
                                                        this.state.upiLotLoading ||
                                                        !(new RegExp("^[0-9]{3,7}$").test(
                                                            this.state.upiLotInput
                                                        ))
                                                    }
                                                >
                                                    Search
                          </button>
                                            </div>
                                            {this.state.upiLotLoading && <LoadingSpinner />}
                                        </div>
                                    )}
                            </form>
                            <div className="container">
                                <div className="row">
                                    {this.state.upiLotResult[0] === "No data available" && <p>No result found for {this.state.upiLotInput}.</p>}
                                    {(this.state.upiLotResult.length > 0 && this.state.upiLotResult[0] !== "No data available") &&
                                        this.state.upiLotResult.map(lot => (
                                            <div className="col-sm" key={lot.attributes.UPI}>
                                                <h6 className="title">UPI: {lot.attributes.UPI}</h6>
                                                <p className="text">
                                                    Negeri: {/*{ lot.attributes.NEGERI }*/} {this.state.queryNAM_NEGERI} <br />
                                                    Daerah: {/*{lot.attributes.DAERAH} */} {this.state.queryNAM_DAERAH} <br />
                                                    Mukim: {/*{lot.attributes.MUKIM} */} {this.state.queryNAM_MUKIM} <br />
                                                    Seksyen: {lot.attributes.SEKSYEN} <br />
                                                    Lot: {lot.attributes.LOT} <br />
                                                    <a href="#" onClick={() => this.zoomUPILot(lot)}>
                                                        <span
                                                            aria-hidden="true"
                                                            className="esri-popup__icon esri-icon-zoom-in-magnifying-glass"
                                                        ></span>
                                                        Zoom to
                            </a>
                                                </p>
                                                <hr />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>

                <div id="DrawAreaDetailsTable" className="containers">                    
                    <div className="row">
                        {this.props.sketchGeometries.map((sketchGeometry, index) => (
                            <div key={index} className="col-sm-12 col-md-6 col-lg-4">
                                <table key={index}>
                                    <thead><tr><th style={{ color: 'white', textTransform: 'capitalize' }} id={sketchGeometry.BufferId}>{sketchGeometry.BufferId.replace('_', ' ')}</th><th style={{ color: 'white' }}>No. of Features</th></tr></thead>
                                    <tbody>
                                        <tr><td>Manhole</td><td className="td-record">{sketchGeometry.Manhole}</td></tr>
                                        <tr><td>Gravity Mains</td><td className="td-record">{sketchGeometry.GravityMains}</td></tr>
                                        <tr><td>Pressurized Mains</td><td className="td-record">{sketchGeometry.PressurizedMains}</td></tr>
                                        <tr><td>Public STP</td><td className="td-record">{sketchGeometry.PublicSTP}</td></tr>
                                        <tr><td colSpan="2" className="table-footer">Total Area: {sketchGeometry.Area} km<sup>2</sup></td></tr>
                                        <tr><td colSpan="2" className="table-footer">Price: RM {(sketchGeometry.Manhole === 0 && sketchGeometry.GravityMains === 0 && sketchGeometry.PressurizedMains === 0 && sketchGeometry.PublicSTP === 0 && sketchGeometry.NPSServiceArea === 0) ? 0 : sketchGeometry.Price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td></tr>
                                        {/*<tr><td colSpan="2"><h6 style={{ color: 'black' }}>Total Area: {sketchGeometry.Area} km<sup>2</sup></h6></td></tr>
                                        <tr><td colSpan="2"><h6 style={{ color: 'black' }}>Price: RM {sketchGeometry.Price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h6></td></tr>*/}

                                    </tbody>
                                </table>

                                <button type="button" className="col-sm-12 col-md-6 col-lg-4 btn btn-primary" disabled={ sketchGeometry.AddToCart || (sketchGeometry.Manhole === 0 && sketchGeometry.GravityMains === 0 && sketchGeometry.PressurizedMains === 0 && sketchGeometry.PublicSTP === 0 && sketchGeometry.NPSServiceArea === 0) === true} onClick={() => this.props.addToCartItem(sketchGeometry)} > Add to Cart </button>
                                <button type="button" className="col-sm-12 col-md-5 col-lg-3 btn btn-secondary" onClick={() => {
                                    this.zoomToBookmark({
                                        target: sketchGeometry.BufferGraphic["geometry"]
                                    });
                                }} > Zoom </button>
                                <button type="button" className="col-sm-12 col-md-6 col-lg-4 btn btn-danger" onClick={() => {
                                    this.deleteGraphic({
                                        target: sketchGeometry.BufferId
                                    });
                                }} > Delete </button>
                            </div>
                        ))}
                        {this.state.loading && (<div className="col-sm-12 col-md-6 col-lg-4 p-5">
                            <center>
                                <h4 className="loading">
                                    Please wait to get feature counts.
                                </h4>
                                <br />
                                <div className="spinner-border text-success" role="status">
                                    <span className="sr-only">Loading</span>
                                </div>
                            </center>
                        </div>)}
                    </div>
                </div>
            </div>
        );
    }
}

export default UserDefinedRegionMapForm;



// WEBPACK FOOTER //
// ./src/components/UserDefinedRegion/UserDefinedRegionMapForm.js